import { FC } from "react";
import DashboardWidgetCalendarList from "./DashboardWidgetCalendarList";
import { DashboardWidgetContainer } from "./DashboardWidgetsStyles";
import DashboardWidgetDemands from "./DashboardWidgetDemands";

const DashboardWidgets: FC = () => {
  return (
    <DashboardWidgetContainer>
      <DashboardWidgetDemands />
      <DashboardWidgetCalendarList />
    </DashboardWidgetContainer>
  );
};

export default DashboardWidgets;
